module.exports = __webpack_public_path__ + "img/alan.f225ab21.jpeg";